import * as THREE from 'three';

/**
 * Metres per screen pixel for either camera type — CLAUDE.md rule: never
 * `camera.position.distanceTo()` in ortho (Viewer.tsx dollies the ortho
 * camera to 1000 m, so the distance is meaningless there). `target` must be
 * a WORLD position (perspective branch only); inside a floating-origin group
 * read it with `getWorldPosition`, never `object.position`.
 *
 * It lives in `lib/three` rather than beside its first caller because several
 * scene components need it (`AlignmentOverlay`, `StationBands`,
 * `StationSectionOverlay`) and a component importing another component only to
 * reach a maths helper is how a render tree acquires an import cycle.
 */
export function unitsPerPixel(camera: THREE.Camera, size: { height: number }, target: THREE.Vector3): number {
  if (camera.type === 'OrthographicCamera') {
    const o = camera as THREE.OrthographicCamera;
    return Math.abs(o.top - o.bottom) / Math.max(o.zoom, 1e-6) / Math.max(size.height, 1);
  }
  const p = camera as THREE.PerspectiveCamera;
  const dist = camera.position.distanceTo(target);
  const vFov = (p.getEffectiveFOV?.() ?? p.fov) * (Math.PI / 180);
  return (2 * dist * Math.tan(vFov / 2)) / Math.max(size.height, 1);
}
